import { createSelector } from 'reselect';
import { getCurrentQuery } from 'src/selectors/getCurrentQuery';
import { getSuggestData } from 'src/selectors/getSuggestData';

export const getSuggestions = createSelector([
        getCurrentQuery,
        getSuggestData,
    ], (query, suggests) => suggests
        .map((suggestion) => suggestion.query)
);
